//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";
import { initialiseForm } from "@donutteam/document-builder-components/src/client.js";

import { createEmailChangeToken } from "../../../../api/routes/v7/emailChangeToken/create.schemas.js";

//
// Component
//

export function initialiseEmailChangeForm(emailChangeForm: HTMLFormElement)
{
	const apiUrl = BrowserUtilities.ElementClientLib.getStringDataOrThrow(emailChangeForm, "apiUrl");

	const emailInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(emailChangeForm, `input[name="email"]`);

	const passwordInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(emailChangeForm, `input[name="password"]`);

	initialiseForm(emailChangeForm,
		async () =>
		{
			const response = await createEmailChangeToken(apiUrl, emailInput.value, passwordInput.value);

			if (!response.success)
			{
				return {
					restoreInputs: true,
					notices: response.errors.map((error) => ({ type: "warning", message: error.message, dismissible: true })),
				};
			}

			return {
				restoreInputs: true,
				notices: [ { type: "success", message: "We've sent a confirmation email to your new email address. Please confirm it.", dismissible: true } ],
			};
		});

	emailChangeForm.classList.add("initialised");
}

export function initialiseEmailChangeForms()
{
	const emailChangeForms = document.querySelectorAll<HTMLFormElement>(".component-email-change-form:not(.initialised)");

	console.log("[EmailChangeForm] Initialising " + emailChangeForms.length + " instances...");

	for (const emailChangeForm of emailChangeForms)
	{
		try
		{
			initialiseEmailChangeForm(emailChangeForm);
		}
		catch (error)
		{
			console.error("[EmailChangeForm] Error initialising:", emailChangeForm, error);
		}
	}
}